<template>
  <button class='fill'>
    <a v-if='block.content.link.type!="page"' :href='block.content.link.value' target='_blank' v-html='block.content.text'/>
    <router-link v-if='block.content.link.type=="page"' :to='pageFromUUID(block.content.link.value).uri' v-html='block.content.text'/>
  </button>
</template>


<script>
import mixins from './.././mixins.js';

export default {
  props: ['block'],
  mixins: [mixins], //kirby(), urltopath(), etc
}
</script>

<style>
  button.fill {
    margin-top: 2rem;
    padding: 0;
    border-radius: 3rem;
  }

  button a {
    display: inline-block;
    padding: 0.75em 2em 0.8em;
  }
</style>
